/**
 * URL-hash keys for the qr-review feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Keys stay colocated with the feature (not centralized) so no cross-feature
 * imports are needed — the same convention as per-feature i18n namespaces.
 */
export const QR_REVIEW_HASH = {
  /** `#reject` — reject-batch dialog (detail page). */
  reject: 'reject',
  /** `#enhance` — image enhancement panel (detail page). */
  enhance: 'enhance',
  /** `#scan` — camera QR scan dialog (listing). */
  scan: 'scan',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete',
  /** `#pages` — page-list Sheet, below the `lg` two-panel breakpoint. */
  pages: 'pages',
  /** `#verdict` — verdict/metrics panel Sheet, below the `lg` breakpoint. */
  verdict: 'verdict'
} as const;

export type QrReviewHashKey =
  (typeof QR_REVIEW_HASH)[keyof typeof QR_REVIEW_HASH];
